import { useMemo } from 'react'
import { getEarliestLastTime } from 'lib/businessHour'
import { DayOfWeekType } from 'lib/daysOfWeek'
import { BusinessTimeType } from 'types/store'
import { StoreCalendarType } from 'types/storeCalendar'

const useEarliestBusinessTime = (
  daysOfWeek: DayOfWeekType[],
  businessTime: BusinessTimeType,
  time: 'order_start_time' | 'last_order_time' | 'last_pickup_time',
  temporaryOpen?: StoreCalendarType
): string => {
  return useMemo(() => {
    // 臨時営業日であれば臨時営業日の時刻を返す
    if (temporaryOpen && temporaryOpen[time]) {
      const temporaryTime = temporaryOpen[time]
      if (!temporaryTime) return getEarliestLastTime(daysOfWeek, businessTime)
      return temporaryTime
    } else {
      return getEarliestLastTime(daysOfWeek, businessTime)
    }
  }, [daysOfWeek, businessTime, time, temporaryOpen])
}

export default useEarliestBusinessTime
